// The CALENDAR_SYNC_* / GITHUB_SYNC_* exports are gone. They addressed the
// `calendar-sync` and `github-sync` Supabase edge functions, which were deleted
// with that plane — every consumer was POSTing into a void behind its own
// catch. Calendar sync is now sdk.calendarSync() → POST /core/calendar/sync;
// GitHub sync is a server-side cron worker with no client trigger at all.
//
// They were also evaluated at MODULE LOAD (`restHeaders()` at import time), so
// the captured header was whatever the token was before sign-in.

// Pure SDK fetch adapter — every `fetch:` decl in this app routes through
// sdk.execute(). registerSdkAdapter() in bootShell binds the SDK instance
// at boot, so `{ adapter: 'sdk' }` here is sufficient — no per-decl sdk
// argument needed. The previous metaFetchConfig (per-decl Supabase fallback
// for unmigrated decls) is no longer required because every consumer now
// uses an SDK entity route prefix (workspaceProject.*, auth.*, organization,
// workspace, project, marketplace.*, file, screenshot, i18n.*).
//
// No per-decl `sdk`: the boot binds the SDK (shared bootPrepare →
// registerSdkAdapter({ sdk })) before anything mounts, in BOTH builds. A
// module-scope getSDK() here published as `"sdk": ""`, and the adapter
// merges the decl OVER the bound options, so the published shell's adapter
// had no SDK at all.
//
// `themeStorageKey`: the stored theme choice paints BEFORE the first frame
// in both builds — the published page's inline theme script and smbls
// create() both read `context.themeStorageKey` (the parcel boot also passes
// it to create()). Without it a published shell painted the OS scheme and
// never the person's stored choice.
export default {
  useReset: true,
  useVariable: true,
  useFontImport: true,
  useIconSprite: true,
  useSvgSprite: true,
  useDefaultConfig: true,
  useDocumentTheme: true,
  verbose: false,
  globalTheme: 'auto',
  themeStorageKey: 'themeMode',
  fetch: { adapter: 'sdk' }
}
